module.exports = __webpack_public_path__ + "static/media/Hester Loo.665da71e.jpeg";